module.exports = __webpack_public_path__ + "img/Veritas.75394d0c.png";